/**
 * 日志上报辅助函数
 * 提供便捷的上报接口，自动判断优先级
 */

import metricReporter, { ReportPriority, MetricData } from './metricReporter.ts';

/**
 * 判断是否为错误类型的上报
 */
function isErrorType(type: string): boolean {
  return type.toLowerCase().includes('error') ||
    type.toLowerCase().includes('fail') ||
    type.toLowerCase().includes('timeout');
}

/**
 * 智能上报 - 自动判断优先级
 * 错误日志使用立即上报，成功日志使用延迟上报
 */
export function smartReport(data: MetricData) {
  const isError = isErrorType(data.tags?.type || '');
  const priority = isError ? ReportPriority.IMMEDIATE : ReportPriority.DEFERRED;
  metricReporter.report(data, priority);
}

/**
 * 立即上报 - 用于关键错误
 */
export function reportImmediate(data: MetricData) {
  metricReporter.report(data, ReportPriority.IMMEDIATE);
}

/**
 * 延迟上报 - 用于成功日志和性能指标
 */
export function reportDeferred(data: MetricData) {
  metricReporter.report(data, ReportPriority.DEFERRED);
}

export default {
  smartReport,
  reportImmediate,
  reportDeferred,
};
